export const SITE_URL = "https://www.finnhouse.fi";
export const SITE_NAME = "Finnhouse";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.png`;

export const buildCanonicalUrl = (pathname: string): string => {
  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
  if (path === "/") return `${SITE_URL}/`;
  return `${SITE_URL}${path}`;
};
